interface BlueWrapperProps {
  children: React.ReactNode;
}

export const BlueWrapper = ({ children }: BlueWrapperProps) => (
  <div className="dark:bg-tertiary rounded-2xl border border-[#E4DBFD] bg-gradient-to-r from-[#E5DBFF] to-[#FAF9FF] p-6 dark:bg-gradient-to-r dark:from-[#1F1F39] dark:to-[#1F1F39]">
    {children}
  </div>
);
